import { Link } from 'react-router-dom'

const RoundedButtonLink = (props) => {
    return (
        <Link to={props.path} className='flex flex-1'>
            <button className='rounded-[6.25rem]' style={{ height: props.height, backgroundColor: props.bgColor, flex: props.flex ? 1 : null }}>
                <p className='font-montserrat font-semibold text-white'>{props.text}</p>
            </button>
        </Link>
    )
}

export default RoundedButtonLink